/**
 * @fileoverview 插件主程序，运行在官网
 */

import React from "react"
import ReactDOM from "react-dom"
import App from "./App"

const videoWrap = document.querySelector(
  ".tpm-prod-hero__video-wrap",
) as HTMLElement

console.log("[数字人插件] 插件挂载中...")

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  videoWrap,
  () => {
    console.log("[数字人插件] 插件挂载完成")
  },
)
